 const swiper = new Swiper('.swiper:not(#cart-slider)', {
  direction: 'horizontal',
  loop: true,
  slidesPerView: 1,
  speed: 400,
  spaceBetween: 10,
  autoplay: {
   delay: 4000,
 },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1600: {
      slidesPerView: 5,
    },
    1440: {
      slidesPerView: 3,
    },
    768: {
      slidesPerView: 2,
    }
  }
});
const UTILS = {
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  },
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  }
};

(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductGroups', () => ({
      mounted() {
        (async () => {
          let res = await fetch('/?sections=product-groups').then(res => res.json());
          let $res = UTILS.ConvertStringToHTML(res['product-groups']);
          UTILS.ConvertStringToJS($res.querySelector('[data-product_groups]').innerHTML);
          document.dispatchEvent(new CustomEvent('product-groups-loaded'));
        })();
      }
    }));

    Alpine.data('ColorSwatches', () => ({
      mounted() {
        let am = this;
        am.LoadSwatches();
        document.addEventListener('product-groups-loaded', am.LoadSwatches.bind(am));
      },
      LoadSwatches() {
        if (typeof PRODUCT_GROUPS == 'undefined') return;

        let am = this;
        let product_handle = am.$el.dataset.product;
        let group = PRODUCT_GROUPS.find(group => {
          return group.products.map(p => p.handle.join('')).indexOf(product_handle) !== -1;
        });

        // console.log(group)
        // if matching group, add swatches
        if (group) {
          group.products
          // .filter(item => item.handle.indexOf(product_handle) == -1)
          .forEach((item) => { 
            if (item.handle.indexOf(product_handle) == -1) {
              am.$el.insertAdjacentHTML('beforeend', item.color_swatch);
            }
            else {
              am.$el.insertAdjacentElement('beforeend', am.$el.querySelector('label'));
              am.$el.insertAdjacentElement('beforeend', am.$el.querySelector('input'));
              am.$el.insertAdjacentElement('beforeend', am.$el.querySelector('div.swatch-element'));
            }
          });

          am.$el.removeAttribute('x-cloak-op');
        }
      }
    }));
  });
})();

$(document).ajaxSuccess(function(event, xhr, settings) {
  if (settings.url && (
    settings.url.includes('/cart/update.js') || 
    settings.url.includes('/cart/change.js') ||
    settings.url.includes('/cart/add.js')
  )) {
    setTimeout(function() {
      reloadCartPaymentTerms();
    }, 300);
  }
});

function reloadCartPaymentTerms() {
  const $paymentTermsContainer = $('.payment-plans-container');
  
  if ($paymentTermsContainer.length === 0) return;
  
  $.get('/?section_id=header', function(html) {
    const $newContent = $(html).find('.payment-plans-container');
    
    if ($newContent.length) {
      $paymentTermsContainer.html($newContent.html());
      
      setTimeout(function() {
        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
      }, 150);
    }
  });
}

$(document).ready(function() {
  $(document).on('click', '[name="checkout"], [value="Checkout"]', function(e) {
    const $btn = $(this);
    const $form = $btn.closest('form');
    
    if ($btn.data('nvd-clicked')) {
      return true;
    }
    
    $btn.data('nvd-clicked', true);
    
    setTimeout(function() {
      if (!$btn.data('nvd-processing')) {
        $form.submit();
      }
    }, 500);
  });
  
});
